import { auth } from '@/lib/firebase/config';

export interface AnalyzeStyleResponse {
    success: boolean;
    styleExample: string;
}

export interface GeneratePostResponse {
    success: boolean;
    content: string;
}

export async function analyzeStyle(params: { sampleText?: string; pdfBase64?: string }): Promise<AnalyzeStyleResponse> {
    // ✅ Get Firebase Auth token
    const user = auth.currentUser;
    if (!user) {
        throw new Error('You must be signed in to use AI features');
    }
    const token = await user.getIdToken();

    const base = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
    const overrideUrl = import.meta.env.VITE_ANALYZE_STYLE_URL as string | undefined;
    const url = overrideUrl || (base ? `${base}/analyzeWritingStyle` : '/analyzeWritingStyle');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // ✅ Include auth token
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to analyze style');
    }
    return response.json();
}

export async function generatePost(params: { styleExample?: string; draftText: string; title?: string }): Promise<GeneratePostResponse> {
    // ✅ Get Firebase Auth token
    const user = auth.currentUser;
    if (!user) {
        throw new Error('You must be signed in to use AI features');
    }
    const token = await user.getIdToken();

    const base = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
    const overrideUrl = import.meta.env.VITE_GENERATE_POST_URL as string | undefined;
    const url = overrideUrl || (base ? `${base}/generatePostWithAI` : '/generatePostWithAI');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // ✅ Include auth token
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to generate post');
    }
    return response.json();
}


